import { useEffect, useState } from "react";
import Picker, { PickerValue } from "react-mobile-picker";

export const renderOptions = (options: string[]) => {
  return options.map((option) => (
    <Picker.Item key={option} value={option}>
      {({ selected }) => (
        <div className={selected ? `font-semibold` : ""}>{option}</div>
      )}
    </Picker.Item>
  ));
};

interface InlinePickerProps {
  options: any[];
  value: any;
  setValue: (value: any) => void;
}

export default function InlinePicker({
  options,
  value,
  setValue,
}: InlinePickerProps) {
  const [pickerValue, setPickerValue] = useState<PickerValue>({ value: value });

  useEffect(() => {
    setPickerValue({ value });
    setValue(value);
  }, []);

  useEffect(() => {
    setValue(pickerValue.value);
  }, [pickerValue]);

  return (
    <Picker value={pickerValue} onChange={setPickerValue}>
      <Picker.Column name={'value'}>{renderOptions(options)}</Picker.Column>
    </Picker>
  );
}
